import BaseAPI from '../base'

function queryArchive(cafe_id, start, end) {
    return BaseAPI.get(`preorder/archive`, {
        cafe_id,
        start,
        end
    });
}

function getDeliveryOrders(cafe_id) {
    return BaseAPI.get(`preorder/delivery_orders/${cafe_id}`);
}

export default {
    queryArchive,
    getDeliveryOrders
}